<template>
  <div class="centent-wrapper">
    <user-info @charge="handleShowRenewal"></user-info>
    <stastic-table :data="recordData"></stastic-table>

    <el-dialog
      custom-class="renewal-dialog"
      :show-close="false"
      :visible.sync="dialogVisible"
      width="1100px"
      center
    >
      <div class="title">请选择续费时长</div>
      <div class="content">
        <div
          class="price-item"
          :class="{
            checked: renewalForm.priceId === item.id,
          }"
          @click="handlePrice(item)"
          v-for="(item, index) in priceData"
          :key="index"
        >
          <div class="gift" v-if="item.dayGift">赠送{{ item.dayGift }}天</div>
          <div class="day">{{ item.day }}天卡</div>
          <div class="remark">{{ item.remark }}</div>
          <div class="price">￥{{ item.retailPrice }}</div>
          <div class="price-day">
            ￥{{ (item.retailPrice / (item.day + item.dayGift)).toFixed(2) }}/天
          </div>
          <div class="check el-icon-check"></div>
        </div>
      </div>
      <div class="title">请选择支付方式</div>
      <div class="content">
        <div
          class="price-item"
          :class="{
            checked: renewalForm.payWay === item.name,
          }"
          @click="handlePayWay(item.name)"
          v-for="(item, index) in payWay"
          :key="index"
        >
          <img class="pay-way" :src="item.logo" alt="支付方式" />
          <div class="hr"></div>
          <div class="check el-icon-check"></div>
        </div>
      </div>
      <div class="footer">
        <el-button type="primary" class="renewal-btn" @click="handleRenewal"
          >立即续费</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="confirmPayVisible"
      width="500px"
      center
      custom-class="success-dialog"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <el-button @click="_getPayStatus()">支付完成</el-button>
      <el-button @click="confirmPayVisible = false">取消支付</el-button>
    </el-dialog>

    <el-dialog
      :visible.sync="wechatPayVisible"
      width="500px"
      center
      custom-class="wechat-dialog"
      @close="handleCloseWechatPay"
    >
      <span slot="title" class="diaTitle">微信支付</span>
      <div class="total">
        合计金额： <span class="num">￥{{ amountPay }}</span>
      </div>
      <div class="wxImg">
        <div class="outer">
          <img
            :src="wechatPayUrl"
            style="margin-top: 25px"
            height="200px"
            alt
          />
          <div class="text">请打开微信扫一扫支付</div>
        </div>
        <div class="outer">
          <img src="@/assets/images/wxPay.png" width="200px" alt />
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="paySuccessVisible"
      width="500px"
      center
      custom-class="success-dialog"
      @close="handleClosePaySuccess"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <div class="icon"><i class="el-icon-circle-check-outline"></i></div>
      <div class="title">恭喜您续费成功</div>
      <div class="info">
        <div>
          <span class="label">续费时长：</span>{{ paySuccessForm.buyDay }}天卡
        </div>
        <div>
          <span class="label">续费方式：</span
          >{{ paySuccessForm.type === 2 ? '支付宝' : '微信支付' }}
        </div>
        <div>
          <span class="label">实付金额：</span
          ><span class="amount">￥{{ paySuccessForm.amount }}</span>
        </div>
      </div>
      <el-button type="primary" round @click="handleClosePaySuccess"
        >确认</el-button
      >
    </el-dialog>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import StasticTable from './components/Table.vue'
import UserInfo from './components/UserInfo.vue'
// todo question 这个QRcode是什么?
import QRCode from 'qrcode'
// todo 图片也可以重命名
import alipayLogo from '@/assets/images/alipay.png'
import wechatpayLogo from '@/assets/images/wechatpay.png'
import { parseTime, minAndSecond, gender } from '@utils'
import {
  getTrainRecord,
  getRenewalList,
  wechatPay,
  getPayStatus,
} from '@api/train'
import { namespace } from 'vuex-class'
import { AccountType } from '@/constant/user'
const moduleUser = namespace('user')
const ALIPAY = 'ALIPAY'
const WECHATPAY = 'WECHATPAY'
@Component({
  components: {
    StasticTable,
    UserInfo,
  },
})
// 注意修改class名
export default class MyAccount extends Vue {
  @Prop(Object)
  data

  recordData = []
  dialogCharge = false
  confirmPayVisible = true

  handleCharge() {
    this.dialogCharge = true
  }

  @moduleUser.State userInfo
  @moduleUser.Getter isExpire
  @moduleUser.Getter renewalQrCode
  @moduleUser.Getter phone
  @moduleUser.Getter address
  @moduleUser.Getter role

  introForm = {}
  introDialog = false
  parseTime = parseTime
  minAndSecond = minAndSecond
  gender = gender
  recordData = []
  loading = false
  dialogVisible = false
  priceData = []
  ALIPAY = ALIPAY
  WECHATPAY = WECHATPAY
  payWay = [
    {
      name: ALIPAY,
      logo: alipayLogo,
    },
    {
      name: WECHATPAY,
      logo: wechatpayLogo,
    },
  ]
  renewalForm = {
    priceId: '',
    payWay: '',
  }
  wechatPayUrl = ''
  wechatPayVisible = false
  amountPay = ''
  tradeNo = ''
  payStatusTimer = null
  paySuccessForm = {
    amount: '',
    buyDay: '',
    type: '',
  }
  paySuccessVisible = false
  expireVisible = false
  defaultPhone = '400-998-6952'
  AccountType = AccountType

  created() {
    if (this.$route.query.out_trade_no) {
      this._getPayStatus(this.$route.query.out_trade_no)
    } else {
      this._getTrainRecord()
    }
    if (this.isExpire) {
      if (this.userInfo.onlineRenewal) {
        this.handleShowRenewal()
      } else {
        this.expireVisible = true
      }
    }
  }

  async handleShowRenewal() {
    this.dialogVisible = true
    this.renewalForm.priceId = ''
    this.renewalForm.payWay = ''
    await this._getRenewalList()
  }

  // todo 类似这种写法是怎么回事?{}
  handlePrice({ id, retailPrice }) {
    this.renewalForm.priceId = id
    this.amountPay = retailPrice
  }

  handlePayWay(name) {
    this.renewalForm.payWay = name
  }

  // todo question 重点支付逻辑!!
  async handleRenewal() {
    if (!this.renewalForm.priceId)
      return this.$message.warning('请选择续费时长')
    if (!this.renewalForm.payWay) return this.$message.warning('请选择支付方式')
    if (this.renewalForm.payWay === ALIPAY) {
      this.confirmPayVisible = true
      // 这个路径是怎么解决的,这应该是直接跳转到支付宝的支付路径
      const routerData = this.$router.resolve({
        path: '/alipay',
        query: {
          priceId: this.renewalForm.priceId,
        },
      })
      console.log(this.routerData, '测试')
      window.open(routerData.href, '_blank')
    } else if (this.renewalForm.payWay === WECHATPAY) {
      const { data } = await wechatPay(this.renewalForm.priceId)
      console.log(data, '微信支付的具体信息,一次')
      // 解析拿到微信的url
      const url = JSON.parse(data.result).code_url
      // 拿到订单号
      this.tradeNo = data.tradeNo

      // todo question 这个是获取的什么信息?
      this.wechatPayUrl = await QRCode.toDataURL(url)
      this.wechatPayVisible = true
      // 每两秒查询一次状态
      this.payStatusTimer = window.setInterval(async () => {
        this._getPayStatus(this.tradeNo)
      }, 2000)
    }
  }

  handleCloseWechatPay() {
    window.clearInterval(this.payStatusTimer)
  }

  handleClosePaySuccess() {
    this.$router.push({ query: { curTrainType: 'myAccount' } })
    location.reload()
  }

  async _getRenewalList() {
    try {
      const { data } = await getRenewalList()
      this.priceData = data
      // todo 空的
      console.log(this.priceData, 'priceData')
    } catch (error) {
      console.log(error)
    }
  }

  async _getTrainRecord() {
    try {
      this.loading = true
      const { data } = await getTrainRecord()
      this.recordData = data
    } catch (error) {
      console.log(error)
    } finally {
      this.loading = false
    }
  }

  async _getPayStatus(id) {
    const { data } = await getPayStatus(id)
    console.log(data, '测试支付状态')
    if (data.paySuccess) {
      this.paySuccessForm = data
      this.wechatPayVisible = false
      this.paySuccessVisible = true
    } else if (data.type === 2) {
      this.$message.warning('没有查询到支付结果')
      this.confirmPayVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.centent-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px 100px;
}
/deep/ .renewal-dialog {
  border-radius: 10px;
  margin: 2vh auto !important;
  .el-dialog__header {
    height: 0;
    padding: 0;
    margin: 0;
  }
  .el-dialog__body {
    padding: 0px 70px;
    overflow: hidden;
    .title {
      margin: 50px 0 30px 0;
      font-size: 24px;
      color: #333;
      &::before {
        content: ' ';
        display: inline-block;
        width: 5px;
        height: 24px;
        background: #f8ac34;
        border-radius: 3px;
        vertical-align: middle;
        margin-right: 10px;
      }
    }
    .content {
      display: grid;
      gap: 40px;
      grid-template-columns: repeat(auto-fill, 280px);
      justify-content: space-between;
      .price-item {
        overflow: hidden;
        width: 280px;
        border-radius: 12px;
        text-align: center;
        border: 2px solid #c6c6c6;
        &:hover {
          cursor: pointer;
        }
        &.checked {
          border: 2px solid #fecb00;
          .check {
            background: #fecb00;
          }
          .gift {
            background: #fecb00;
            color: #ca7c00;
          }
        }
        .gift {
          position: absolute;
          width: 127px;
          height: 35px;
          border-radius: 10px 0 10px 0;
          font-size: 18px;
          line-height: 35px;
          opacity: 0.8;
          background: #c6c6c6;
        }
        .day {
          margin-top: 60px;
          height: 21px;
          font-size: 20px;
          font-weight: bold;
          color: #333333;
        }
        .remark {
          margin-top: 10px;
          height: 15px;
          font-size: 14px;
          font-weight: bold;
          color: #666666;
          opacity: 0.8;
        }
        .price {
          margin-top: 15px;
          height: 24px;
          font-size: 30px;
          font-weight: bold;
          color: #f8ac34;
        }
        .price-day {
          margin-top: 15px;
          height: 15px;
          font-size: 16px;
          font-weight: bold;
          color: #666666;
          opacity: 0.8;
        }
        .pay-way {
          margin-top: 35px;
        }
        .hr {
          height: 2px;
          margin: 30px 30px 0;
          border: 2px solid #c6c6c6;
          opacity: 0.3;
        }
        .check {
          margin: 30px 0;
          width: 200px;
          height: 40px;
          border-radius: 20px;
          color: #fff;
          font-size: 30px;
          line-height: 40px;
          background: #c6c6c6;
        }
      }
    }
    .footer {
      text-align: center;
      .renewal-btn {
        margin: 60px auto;
        width: 218px;
        height: 48px;
        border-radius: 24px;
        font-size: 18px;
        font-weight: bold;
        color: #ffffff;
      }
    }
  }
}
.wxImg {
  display: flex;
  flex-flow: row;
  justify-content: space-around;
  .outer {
    width: 200px;
    display: flex;
    flex-flow: column;
    .text {
      width: 100%;
      height: 30px;
      background-color: #62b900;
      color: white;
      line-height: 30px;
      text-align: center;
      font-size: 18px;
    }
  }
}
/deep/ .wechat-dialog {
  border-radius: 10px;
  .total {
    text-align: center;
    font-size: 18px;
    color: #666666;
    line-height: 30px;
    .num {
      color: #595ed3;
      margin-top: 5px;
      font-size: 30px;
    }
  }
}

/deep/ .success-dialog {
  border-radius: 10px;
  .el-dialog__body {
    text-align: center;
  }
  .icon {
    font-size: 120px;
    line-height: 1;
    margin-top: 10px;
    color: #585ad6;
  }
  .title {
    margin-top: 40px;
    height: 23px;
    font-size: 24px;
    color: #080808;
  }
  .info {
    margin: 40px auto;
    width: 230px;
    font-size: 20px;
    color: #666666;
    text-align: left;
    line-height: 35px;
    .label {
      margin-right: 30px;
    }
    .amount {
      color: #f8ac34;
    }
  }
  .el-button {
    width: 220px;
    font-size: 18px;
    font-weight: bold;
  }
}
.expire-dialog {
  text-align: center;
  .title {
    font-size: 24px;
    margin-bottom: 30px;
  }
  .qr-code {
    width: 220px;
    border: 1px dashed #606266;
    padding: 10px;
  }
  .info {
    font-size: 16px;
    font-weight: 700;
    margin: 30px 40px 0;
    div {
      margin-top: 10px;
    }
  }
}
</style>
